module.exports = __webpack_public_path__ + "46319144478886460132f0cfeaefc7da.svg";